// extracted by mini-css-extract-plugin
module.exports = {"rating":"styles_rating__clzbQ","stars":"styles_stars__e_4Zu","star":"styles_star__utLZ5","unchecked":"styles_unchecked__tBTkW","interactive":"styles_interactive__dFeIx"};